import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useRef, useState } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import * as videoStoryStyles from './VideoStory.scss';
import * as Styles from './View.scss';
import { getInstance as getHtml5VideoPlayerInstance } from '../player/html5VideoPlayer';
import { HorizontalItemSize } from '../components/widgets/items/HorizontalItem';
import { dispatchSkyfireMethods } from '../utils';
import HTML5VideoPlayerEvent from '../player/html5VideoPlayer/players/HTML5VideoPlayerEvent';
import { getDeeplink } from '../utils/getDeeplink';
const videoStoryPlayerContainerId = 'videoStoryPlayerContainer';
function VideoStory(props) {
    var _a;
    useStyles(videoStoryStyles, Styles);
    const { playbackURL, asin, pid, posterUrl, title, durationSeconds, artistInfo, pillNavigator, closeButton, logo, autoPlay, onViewed, onInteraction, onStarted, onResumed, onPaused, onFinished, onStopped, onError, } = props.template;
    const [progress, setProgress] = useState(0);
    const [isPaused, setIsPaused] = useState(true);
    const videoPlayerRef = useRef();
    const timeUpdateEventHandler = () => {
        if (videoPlayerRef.current) {
            setProgress(getProgress(videoPlayerRef.current));
        }
    };
    const playEventHandler = () => {
        setIsPaused(false);
    };
    const pauseEventHandler = () => {
        setIsPaused(true);
    };
    const playingEventHandler = () => {
        if (!videoPlayerRef.current) {
            return;
        }
        const player = videoPlayerRef.current;
        if (player.getLatestPlaybackRequestedPosition() === 0) {
            dispatchSkyfireMethods(props.dispatch, props.template, onStarted);
        }
        else {
            dispatchSkyfireMethods(props.dispatch, props.template, onResumed);
        }
    };
    const endedEventHandler = () => {
        setIsPaused(true);
        dispatchSkyfireMethods(props.dispatch, props.template, onFinished);
    };
    const errorEventHandler = () => {
        setIsPaused(true);
        dispatchSkyfireMethods(props.dispatch, props.template, onError);
    };
    useEffect(() => {
        dispatchSkyfireMethods(props.dispatch, props.template, onViewed);
        if (!playbackURL) {
            return () => { };
        }
        const player = getHtml5VideoPlayerInstance();
        videoPlayerRef.current = player;
        player.setPoster(posterUrl !== null && posterUrl !== void 0 ? posterUrl : '');
        player.addEventListener(HTML5VideoPlayerEvent.TIME_UPDATE, timeUpdateEventHandler);
        player.addEventListener(HTML5VideoPlayerEvent.PLAY, playEventHandler);
        player.addEventListener(HTML5VideoPlayerEvent.PLAYING, playingEventHandler);
        player.addEventListener(HTML5VideoPlayerEvent.PAUSE, pauseEventHandler);
        player.addEventListener(HTML5VideoPlayerEvent.ENDED, endedEventHandler);
        player.addEventListener(HTML5VideoPlayerEvent.ERROR, errorEventHandler);
        player.setAutoplay(autoPlay);
        player.attachToElement(videoStoryPlayerContainerId);
        player.attachSource(playbackURL);
        return () => {
            player.removeEventListener(HTML5VideoPlayerEvent.TIME_UPDATE, timeUpdateEventHandler);
            player.removeEventListener(HTML5VideoPlayerEvent.PLAY, playEventHandler);
            player.removeEventListener(HTML5VideoPlayerEvent.PLAYING, playingEventHandler);
            player.removeEventListener(HTML5VideoPlayerEvent.PAUSE, pauseEventHandler);
            player.removeEventListener(HTML5VideoPlayerEvent.ENDED, endedEventHandler);
            player.removeEventListener(HTML5VideoPlayerEvent.ERROR, errorEventHandler);
        };
    }, [playbackURL]);
    const handleVideoClick = () => {
        dispatchSkyfireMethods(props.dispatch, props.template, onInteraction);
        if (!videoPlayerRef.current) {
            return;
        }
        const videoPlayer = videoPlayerRef.current;
        const wasPlaying = videoPlayer.isPlaying();
        videoPlayer.pause();
        if (wasPlaying) {
            dispatchSkyfireMethods(props.dispatch, props.template, onPaused);
        }
        else {
            if (videoPlayer.isEnded()) {
                videoPlayer.seekTo(0);
            }
            videoPlayer.play();
        }
    };
    const handleSelected = (event, methods = []) => {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        if (videoPlayerRef.current) {
            const videoPlayer = videoPlayerRef.current;
            const wasPlaying = videoPlayer.isPlaying();
            videoPlayer.pause();
            if (wasPlaying) {
                dispatchSkyfireMethods(props.dispatch, props.template, onStopped);
            }
        }
        dispatchSkyfireMethods(props.dispatch, props.template, methods);
    };
    const onClose = (event) => {
        var _a;
        handleSelected(event, closeButton === null || closeButton === void 0 ? void 0 : closeButton.onItemSelected);
        (_a = videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.unload();
    };
    return (React.createElement("div", { className: videoStoryStyles.videoStoryContainer },
        React.createElement("div", { id: "videoStoryPlayerContainer", className: videoStoryStyles.videoStoryPlayerContainer, onClick: handleVideoClick }),
        isPaused && (React.createElement("music-button", { className: videoStoryStyles.videoPlay, onmusicActivate: handleVideoClick, "icon-name": "play", "icon-only": true, variant: "glass", size: "large", role: "button", "aria-disabled": "false", tabindex: "0", refinement: "none" })),
        React.createElement("music-button", { className: videoStoryStyles.videoClose, onmusicActivate: onClose, "icon-name": "cancel", "icon-only": true, variant: "glass", size: "small", role: "button", "aria-disabled": "false", tabindex: "0", refinement: "none" }),
        React.createElement("div", { className: videoStoryStyles.videoInfo },
            React.createElement("div", { className: videoStoryStyles.videoTitle }, title),
            artistInfo && (React.createElement("music-horizontal-item", { className: videoStoryStyles.artistInfo, kind: "circle", size: HorizontalItemSize.Small, "image-src": artistInfo.image, "primary-text": artistInfo.primaryText.text })),
            pillNavigator && (React.createElement("music-button", { className: videoStoryStyles.pillNavigator, variant: "glass", type: "pill", size: "small", role: "button", ariaDisabled: true, tabindex: "0", refinement: "none", "remove-text-transform": true, text: pillNavigator.text, onClick: (event) => {
                    var _a;
                    handleSelected(event, (_a = pillNavigator === null || pillNavigator === void 0 ? void 0 : pillNavigator.primaryLink) === null || _a === void 0 ? void 0 : _a.onItemSelected);
                }, href: getDeeplink((_a = pillNavigator.primaryLink) === null || _a === void 0 ? void 0 : _a.deeplink) }, pillNavigator.text))),
        logo && React.createElement("img", { className: videoStoryStyles.musicLogo, src: logo }),
        React.createElement(VideoControls, { progress: progress })));
}
function getProgress(video) {
    return (video.getCurrentTime() / video.getDuration()) * 100;
}
function VideoControls(props) {
    return (React.createElement("div", { className: videoStoryStyles.videoControls },
        React.createElement("div", { className: videoStoryStyles.videoTimeline },
            React.createElement("div", { className: videoStoryStyles.videoBar },
                React.createElement("div", { className: videoStoryStyles.videoBarInner, style: { width: `${props.progress}%` } })))));
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withStyles(Styles)(connect(null, mapDispatchToProps)(VideoStory));
